module.exports = __webpack_public_path__ + "static/media/gear-yellow.ba185e8a.svg";